import { createContext } from 'react'

// True when the composer is open as an overlay on top of a background route.
// Lives outside routes/index to avoid a circular import via AppLayout.
export const ComposerOverlayContext = createContext(false)
